import { Injectable } from '@angular/core';
import { ConfigService } from '../../../config/config.service';
import Enums from '../../enum/enums';

@Injectable({
  providedIn: 'root',
})
export class UrlParameterMapperService {
  constructor(private readonly configService: ConfigService) {}

  mapUrlToId(urlParameter: Enums.UrlParameter, paramValue: string): any {
    const match = this.getMatch(urlParameter, 'urlParam', paramValue);

    if (!match) {
      throw new Error(`Could not map url parameter ${urlParameter}: ${paramValue} to an id of ${urlParameter}!`);
    }
    return match.id;
  }

  mapIdToUrl(id: any, urlParameter: Enums.UrlParameter) {
    const match = this.getMatch(urlParameter, 'id', id);

    if (!match) {
      throw new Error(`Could not map an id of ${urlParameter}: ${id} to url parameter ${urlParameter}!`);
    }
    return match.urlParam;
  }

  private getMatch(urlParameter: Enums.UrlParameter, property: string, value: any): any {
    switch (urlParameter) {
      case Enums.UrlParameter.workspace: {
        return this.configService.arbeitsbereichConfig.arbeitsbereiche.find(o => o[property] === value);
      }
      case Enums.UrlParameter.tool: {
        return { urlParam: value };
      }
      case Enums.UrlParameter.layer: {
        return { urlParam: value };
      }
      case Enums.UrlParameter.id: {
        return { urlParam: value };
      }
      case Enums.UrlParameter.guid: {
        return { urlParam: value };
      }
      case Enums.UrlParameter.aoid: {
        return { urlParam: value };
      }
      case Enums.UrlParameter.egrid: {
        return { urlParam: value }
      }
      default:
        throw new Error(`Mapping for urlParameter ${urlParameter} is not implemented!`);
    }
  }
}
